export default __webpack_public_path__ + "static/media/code1.8393b5e7.png";